/*global SunergoPlatform*/

/**
 * Initialized form reset hook.
 * @param {object} form - the form item.
 */
const initFormReset = function(form) {
	const inputElements = SunergoPlatform.inputElements;

	const resetButton = form.element.querySelector('[type="reset"]');
	if (!resetButton) return;

	var evt = document.createEvent('HTMLEvents');
	if ('createEvent' in document) evt.initEvent('change', false, true);

	if (form.changeLog) {
		resetButton.show = function(isShown) {
			if (isShown) this.removeAttribute('hidden');
			else this.setAttribute('hidden', 'true');
		};
		form.changeLog.resetButton = resetButton;
	}

	form.element.addEventListener('reset', function() {
		// Do stuff after reset event.
		setTimeout(function() {
			// Fire on change on all fields.
			form.element.querySelectorAll(inputElements).forEach(function(input) {
				if ('createEvent' in document) input.dispatchEvent(evt);
				else input.fireEvent('onchange');
			});
	
			// Reset tom select.
			const tomSelects = form.element.querySelectorAll('[data-tom-select]');
			if (tomSelects && tomSelects.length > 0) {
				tomSelects.forEach(function(selectItem) {
					if (selectItem.tomselect) selectItem.tomselect.setValue(selectItem.dataset.originalValue, true);
				});
			}
	
			// Reset change log.
			if (form.changeLog) {
				form.changeLog.items = [];
				form.changeLog.updateStatus();
			}
		}, 0);
	});
};

export default initFormReset;